import { defineComponent as _defineComponent } from 'vue'
import TableauTextBox from "./TableauTextBox.vue";
import TableauSelectButton from "./select/TableauSelectButton.vue";
import { computed, onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableauSimpleAutocomplete',
  props: {
    modelValue: { type: String, required: true },
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    disabled: { type: Boolean, required: false },
    getAutocompleteItems: { type: Function, required: true },
    maxItems: { type: Number, required: false, default: 5 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;



const value = ref<string>(props.modelValue);

const itemsLoadStatus = ref<"loading" | "success" | "error">("loading");
const allItems = ref<string[]>([]);
const filteredItems = computed<string[]>(() => {
  if (itemsLoadStatus.value !== "success") {
    return [];
  }
  const r = allItems.value.filter(
    (e) => !!e && e.toLowerCase().startsWith((value.value || "").toLowerCase())
  );
  if (r.length > props.maxItems) {
    r.splice(props.maxItems);
  }
  return r;
});
const refEl = ref<HTMLElement | null>(null);
function updateValue(val: string) {
  emits("update:modelValue", val);
  value.value = val;
}
const menuOpen = ref<boolean>(false);
const overlayStyle = ref({ left: "0px", top: "0px", width: "0px" });
function setOpen(open: boolean) {
  menuOpen.value = open;
  if (menuOpen.value) {
    const rect = refEl.value!.getBoundingClientRect();
    overlayStyle.value = {
      left: `${rect.left}px`,
      top: `${rect.bottom}px`,
      width: `${rect.width}px`,
    };
  }
}
async function onBlur() {
  window.requestAnimationFrame(() => setOpen(false));
}
async function loadItems() {
  itemsLoadStatus.value = "loading";
  try {
    allItems.value = await props.getAutocompleteItems();
    itemsLoadStatus.value = "success";
  } catch (e) {
    itemsLoadStatus.value = "error";
  }
}

const menuOptions = computed(() => {
  let isLoading = false;
  let topText: string | undefined;
  let bottomText: string | undefined;

  switch (itemsLoadStatus.value) {
    case "loading":
      isLoading = true;
      topText = "Loading suggestions...";
      break;
    case "error":
      isLoading = true;
      topText = "Failed to load suggestions";
      bottomText = "Enter a value manually";
      break;
    case "success":
      if (!!value.value) {
        if (filteredItems.value.length > 0) {
          topText = `Suggestions for '${value.value}':`;
        } else {
          topText = `No suggestions for '${value.value}'`;
        }
      } else {
        topText = "Start typing to search";
      }
      if (filteredItems.value.length === props.maxItems) {
        bottomText = `Showing top ${props.maxItems} suggestions`;
      }
      break;
  }
  return {
    isLoading,
    topText,
    bottomText,
  };
});

onMounted(() => loadItems());
__expose({
  loadItems,
});

const __returned__ = { props, emits, value, itemsLoadStatus, allItems, filteredItems, refEl, updateValue, menuOpen, overlayStyle, setOpen, onBlur, loadItems, menuOptions, TableauTextBox, TableauSelectButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})